//////////////////
// IMPORTS
//////////////////
// libraries
import Radium from "radium";
import * as React from "react";
import { connect } from "react-redux";
// home-wrapper imports
import { IProps, IContainer } from "./HomeWrapper.d";
import { homeStyles, homeTheme, body } from "./HomeWrapper.styles";
// other components
// eslint-disable-next-line @typescript-eslint/no-var-requires, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
const Div100vh = require("react-div-100vh").default;
import { HomeNav } from "@components/home-nav";
// state
import { IReduxState } from "@state/reducers/root.reducer";
// Material-ui and styles imports
import { MuiThemeProvider, createTheme } from "@material-ui/core/styles";
// create custom material-ui theme
const muiTheme = createTheme(homeTheme);

//////////////////
// COMPONENT
//////////////////
export class HomeWrapperCmpt extends React.Component<IProps, IContainer> {
  public componentDidMount() {
    // important!
    setTimeout(() => {
      (window as any).prerenderReady = true;
    }, 1000);
  }

  public render() {
    const { isChromeExtension } = this.props;

    return (
      <Radium.StyleRoot>
        <MuiThemeProvider theme={muiTheme}>
          <Div100vh>
            <div style={{ ...homeStyles }}>
              {!isChromeExtension ? <HomeNav /> : ""}
              <div style={body}>{this.props.children}</div>
            </div>
          </Div100vh>
        </MuiThemeProvider>
      </Radium.StyleRoot>
    );
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(state: IReduxState, _ownProps: IContainer) {
  return {
    isChromeExtension: state.webExtension.isWebExtension,
  };
}

export const HomeWrapper = connect(mapStateToProps)(HomeWrapperCmpt);
